import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import SuggestionList from "../SuggestionList/index.js";
import VendorShape from "../../shapes/VendorShape.js";
import Suggestion from "../LocalSuggestion/index.js";

var LocalSuggestionList = function LocalSuggestionList(props) {
  return React.createElement(SuggestionList, _extends({}, props, {
    Suggestion: Suggestion
  }));
};

process.env.NODE_ENV !== "production" ? LocalSuggestionList.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.shape(VendorShape))
} : void 0;
export default LocalSuggestionList;